// extracted by mini-css-extract-plugin
export default {"wrapper":"Projects_wrapper__mA8OF","container":"Projects_container__-kPWr","content":"Projects_content__aXqvI"};